<!--工作台-->
<template>
  <div>
    <WorkDetails :visible.sync="showD" :data="showData"></WorkDetails>
    <div class="work border">
      <!-- <div class="work-title pr">普投广告投放项目情况</div>
      <el-select v-model="value" clearable placeholder="请选择您的项目" @change="requestList">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div class="work-data pr">
        <swiper :options="swiperOption2">
          <swiper-slide v-for="item in SumData" :key="$index">
            <ve-line v-if="!item.empty" :data="item" :extend="chartExtend" width="442px" height="300px" class="v-line"></ve-line>
            <div v-else class="work-empty">
              <no-data></no-data>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next2 pa"></div>
        <div class="swiper-button-prev2 pa"></div>
      </div> -->
       <div class='maskInner' v-show="(firstLoginStutes||isShowNewGuide)&&!dialogFlag">
        <div v-for='(item,index) in newGuide' :key='index' :class='`newGuideCommon newGuidelines${index+1}`' v-show="currentIndex===index">
          <div class='brightMask'>
            <img :src="brightMaskArr[index].icon" alt="">
            <span>{{brightMaskArr[index].content}}</span>
          </div>
          <div class='title'>{{index+1}}/5 {{item}}</div>
          <div class='content'>
            <span class="closeButton" v-if="index<4" @click='skip'>不看了，跳过</span>
            <span class='contentButton' type="primary" @click='clickHandler'>知道了</span>
          </div>
        </div>
      </div>
    </div>
    <div class='maskOuter' v-show="(firstLoginStutes||isShowNewGuide)&&!dialogFlag"></div>
    <div class="article border pr" v-if="false">
      <el-tabs v-model="activeName">
        <el-tab-pane class="pr" label="行业动态" name="second">
          <swiper :options="swiperOption3">
            <swiper-slide v-for="(item,index) in indusData" :key="index">
              <div class="article-card border" @click="showDetails(item, '行业动态')">
                <div class="title">{{item.title}}</div>
                <div class="bottom pr">
                  <p>{{item.publishUserName}}</p>
                  <span>{{format(item.publishTime)}}</span>
                  <span class="pa tag">行业动态</span>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </el-tab-pane>
        <el-tab-pane class="pr" label="企业资讯" name="third">
          <swiper :options="swiperOption3">
            <swiper-slide v-for="(item,index) in ArtData" :key="index">
              <div class="article-card border" @click="showDetails(item, '企业动态')">
                <div class="title">{{item.title}}</div>
                <div class="bottom pr">
                  <p>{{item.publisher}}</p>
                  <span>{{format(item.publishTime)}}</span>
                  <span class="pa tag">企业动态</span>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev3 pa" slot="button-prev"></div>
          <div class="swiper-button-next3 pa" slot="button-next"></div>
        </el-tab-pane>
      </el-tabs>
      <div class="swiper-button-prev3 pa" slot="button-prev"></div>
      <div class="swiper-button-next3 pa" slot="button-next"></div>
    </div>
    <template>
      <div class="adv" v-if="this.adverData.length === 0">
        <div class="wrapperAdv">
          <swiper :options="swiperOption1">
            <swiper-slide v-for="(item,index) in adverData" :key="index">
              <template v-if="item.linkUrl.substring(0, 4) === 'http'">
                <a :href="item.linkUrl" target="_blank" style="display: block;width: 100%;height: 100%">
                  <img :src="item.picUrl" alt="">
                </a>
              </template>
              <template v-else>
                <a :href="'http://' + item.linkUrl" target="_blank" style="display: block;width: 100%;height: 100%">
                  <img :src="item.picUrl" alt="">
                </a>
              </template>
            </swiper-slide>
          </swiper>
        </div>
        <div class="swiper-pagination1"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="adv" v-else :class="{'showQuDaoStyle':!showQuDao}">
        <div class="wrapperAdv" v-if="showQuDao">
          <img src="../../assets/images/back/work/adv.png"/>
        </div>
      </div>
    </template>
    <div class="link" v-if="showQuDao">
      <div class="link-tp" v-if="this.GoodData.zszt !== null &&  this.GoodData.zszt !== undefined && this.GoodData.zszt.length !== 0">
        <h1 class="pr">招商智投</h1>
        <span>连锁加盟行业互联网广告的智慧投放</span>
      </div>
      <div class="link-bt" v-if="this.GoodData.zszt !== null &&  this.GoodData.zszt !== undefined && this.GoodData.zszt.length !== 0">
        <ul>
          <li v-for="(item,index) in GoodData.zszt" :key="index"><a :href="item.linkUrl" target="_blank">{{item.title}}</a></li>
        </ul>
      </div>
      <div class="link-tp link-mar-top" v-if="this.GoodData.wjqm !== null &&  this.GoodData.wjqm !== undefined && this.GoodData.wjqm.length !== 0">
        <h1 class="pr">全网营销</h1>
        <span>网聚海量媒体，让营销更具效果</span>
        <!--<a href="">官网</a>-->
        <!--<a href="">公众号</a>-->
      </div>
      <div class="link-bt" v-if="this.GoodData.wjqm !== null &&  this.GoodData.wjqm !== undefined && this.GoodData.wjqm.length !== 0">
        <ul>
          <li v-for="(item,index) in GoodData.wjqm" :key="index"><a :href="item.linkUrl" target="_blank">{{item.title}}</a></li>
        </ul>
      </div>
      <div class="link-tp link-mar-top" v-if="this.GoodData.sqcy !== null &&  this.GoodData.sqcy !== undefined && this.GoodData.sqcy.length !== 0">
        <h1 class="pr">品牌全案</h1>
        <span>连锁加盟行业品牌速建专家</span>
        <!-- <a href="http://www.show-q.com/" target="_blank">官网</a> -->
        <!--<el-popover-->
          <!--placement="top-start"-->
          <!--width="120"-->
          <!--trigger="hover">-->
          <!--<img class="qr-code" src="../../assets/images/footer-wei2.png"/>-->
          <!--<a slot="reference" style="cursor: pointer">公众号</a>-->
        <!--</el-popover>-->
      </div>
      <div class="link-bt last-ul" v-if="this.GoodData.sqcy !== null &&  this.GoodData.sqcy !== undefined && this.GoodData.sqcy.length !== 0">
        <ul>
          <li v-for="(item,index) in GoodData.sqcy" :key="index"><a :href="item.linkUrl" target="_blank">{{item.title}}</a></li>
        </ul>
      </div>
    </div>
  </div>

</template>
<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import Api from '@/api/client/work-bench'
  import ApiItem from '@/api/items'
  import ApiRead from '@/api/customer-good'
  import Moment from 'moment'
  import WorkDetails from '@/components/client/common/WorkDetails'
  export default {
    props: ['dialogFlag', 'isShowNewGuide', 'currentIndex'],
    components: {
      swiper,
      swiperSlide,
      WorkDetails
    },
    data () {
      this.chartExtend = {
        legend: {
          left: 'center',
          top: 15
        },
        grid: {
          left: 'center',
          top: 53,
          width: '90%',
          height: '75%'
        }
      }
      return {
        showQuDao: true,
        adverData: [],
        indusData: [],
        ArtData: [],
        GoodData: {},
        SumData: {},
        showD: false,
        showData: {},
        swiperOption1: {
          loop: true,
          speed: 900,
          notNextTick: true,
          autoplay: true,
          preloadImages: false,
          pagination: {
            el: '.swiper-pagination1',
            clickable: true
          },
          paginationClickable: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        swiperOption2: {
          slidesPerView: 2,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-button-next2',
            prevEl: '.swiper-button-prev2'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        swiperOption3: {
          slidesPerView: 4,
          spaceBetween: 19,
          navigation: {
            nextEl: '.swiper-button-next3',
            prevEl: '.swiper-button-prev3'
          }
        },
        options: [],
        value: '',
        activeName: 'second',
        newGuide: ['查看普通聊天的表单资源', '查看智能聊天的表单和聊天资源', '查看每日项目的广告投放数据报表', '查看项目余额、充值记录、消费报表', '资源实时对接到话务人员EC账号'],
        brightMaskArr: [
          {icon: '/static/images/mseeage_icon.png', content: '招商智投（普投）'},
          {icon: '/static/images/ocpc_icon.png', content: '招商智投（智投）'},
          {icon: '/static/images/extension_icon.png', content: '推广管理'},
          {icon: 'static/images/icon_wallet.png'},
          {icon: 'static/images/resources_icon.png', content: '资源同步crm'}],
        firstLoginStutes: false
      }
    },
    created () {
      if (window.location.host !== 'test-emcp.qudao51.com' && window.location.host !== 'www.qudao51.com') {
        this.showQuDao = false
      }
      if (window.location.host === 'localhost:8030') {
        this.showQuDao = true
      }
      ApiItem.getItems(response => {
        let status = response.data.code
        let body = response.data.data
        if (status === '200') {
          let title = []
          body.forEach(value => {
            title.push({value: value.id, label: value.title})
          })
          this.options = title
        }
      })
      this.getAdver() // 广告
      this.getIndusStr() // 行业资讯
      this.getArticle() // 企业动态
      this.getGood()  // 商品
      this.requestList()
      this.firstLoginStutes = JSON.parse(sessionStorage.getItem('user')).firstLoginStutes
    },
    mounted () {
      this.firstLoginStutes = JSON.parse(sessionStorage.getItem('user')).firstLoginStutes
    },
    methods: {
      requestList () {
        this.GoodData = {
          sqcy: [],
          wjqm: [],
          zszt: []
        }
        Api.getSummary({'search': {itemId: this.value, pageSize: 15}}, response => {
          let status = response.data.code
          let body = response.data.data || []
          if (status === '200') {
            if (body && body.length > 0) {
              this.SumData.impression = this.forPack(body, {colums: ['日期', '展现量']}, 'impression')
              this.SumData.click = this.forPack(body, {colums: ['日期', '点击量']}, 'click')
              this.SumData.feedback = this.forPack(body, {colums: ['日期', '留言量']}, 'feedback')
              this.SumData.talk = this.forPack(body, {colums: ['日期', '有效对话量']}, 'talk')
              this.SumData.phone = this.forPack(body, {colums: ['日期', '要电话量']}, 'phone')
              this.$forceUpdate()
            } else {
              this.SumData.impression = {columns: [], rows: [], empty: true}
              this.SumData.click = {columns: [], rows: [], empty: true}
              this.SumData.feedback = {columns: [], rows: [], empty: true}
              this.SumData.costCoin = {columns: [], rows: [], empty: true}
              this.SumData.phone = {columns: [], rows: [], empty: true}
            }
          } else {
            this.SumData = []
          }
        })
      },
      getAdver () {
        Api.getAdver(response => {
          let status = response.status
          let body = response.data
          if (status >= 200 && status <= 204) {
            this.adverData = body
          } else {
            this.adverData = []
          }
        })
      },
      getGood () {
        Api.getGood(response => {
          let status = response.status
          let body = response.data
          if (status >= 200 && status <= 204) {
            this.GoodData.sqcy = body.map.sqcy
            this.GoodData.wjqm = body.map.wjqm
            this.GoodData.zszt = body.map.zszt
          } else {
            this.GoodData = {}
          }
        })
      },
      getIndusStr () {
        Api.getIndusStr(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.indusData = body
          } else {
            this.indusData = []
          }
        })
      },
      getArticle () {
        Api.getArticle(response => {
          let status = response.data.code
          let body = response.data
          if (status === '200') {
            this.ArtData = body.data
          } else {
            this.ArtData = []
          }
        })
      },
      format (time) {
        return Moment(time, 'YYYYMMDD').format('YYYY-MM-DD')
      },
      formats (time) {
        return Moment(time, 'YYYYMMDD').format('MM/DD')
      },
      showDetails (data, article) {
        let Obj = Object.assign({}, data, {'article': article})
        this.showD = true
        this.showData = Obj
        ApiRead.readsh(response => {
          let status = response.status || 0
          if (status === 200 || status === 204) {
            this.$message.success('完成阅读任务')
          }
        })
        ApiRead.get({id: this.showData.id}, response => {
          let status = response.status || 0
          if (status === 200 || status === 204) {

          }
        })
      },
      forPack (data, tem, target) {
        let col1 = tem.colums[0]
        let col2 = tem.colums[1]
        let rows = []
        if (data.length === 0) {
          return {columns: [], rows: [], empty: true}
        }
        data.forEach(item => {
          rows.push({[col1]: this.formats(item.day), [col2]: item[target]})
        })
        return {columns: tem.colums, rows: rows}
      },
      clickHandler () {
        this.currentIndex++
        if (this.currentIndex > 4) {
          this.skip()
        }
      },
      changeFirstLogin () {
        Api.changeFirstLogin(response => {
          sessionStorage.setItem('user', JSON.stringify(response.data.data))
        })
      },
      skip () {
        if (this.firstLoginStutes === true) {
          this.changeFirstLogin()
        }
        this.firstLoginStutes = false
        this.$emit('closeNewGuide')
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';
  .work {//广告投放
    position: relative;
    width: 100%;
    //height:433px;
    //padding: 20px 43px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: white;
    &-title {
      font-size: 16px;
      font-weight: bold;
      color: #085ecc;
      margin-bottom: 21px;
      &:before {
        content: '';
        position: absolute;
        width: 2px;
        height: 16px;
        background: rgba(8, 94, 204, 1);
        left: -10px;
        top: 4px;
      }
    }
    &-data {
      .work-empty{padding: 90px 0 48px;}
      &-wrap {
        > div {
          width: 49%;
          border: 1px solid rgba(230, 230, 230, 1);
        }
        .top {
          font-size: 14px;
          text-align: center;
          height: 47px;
          line-height: 47px;
          border-bottom: 1px solid rgba(230, 230, 230, 1);
          span {
            color: #085ECC;
          }
        }
      }
    }
    .maskInner{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 13;
      .newGuideCommon{
        position: absolute;
        width:274px;
        height:111px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 5px 0px rgba(0, 0, 0, 0.3);
        border-radius:10px;
        &::before{
          border-left: 20px solid transparent;
          border-right: 20px solid #fff;
          border-top: 20px solid transparent;
          border-bottom: 20px solid transparent;
          content: "";
          position: absolute;
          left: -40px;
          top: 15px;
        }
        .brightMask{
          padding: 6px 10px;
          border-radius: 20px;
          background: rgba($color: #fff, $alpha: 1);
          position: absolute;
          left: -190px;
          top: 20px;
          font-size:14px;
          font-weight:400;
          color:rgba(48,49,51,1);
          display: flex;
          align-items: center;
          justify-content: space-around;
          vertical-align: middle;
        }
        img{
          width: 14px;
          height: 14px;
          margin: 5px;
        }
        .title{
          height:14px;
          font-size:14px;
          font-weight:500;
          color:rgba(122,129,137,1);
          line-height:23px;
          margin: 25px 0 0 16px;
        }
        .content{
          margin: 30px 0px 0px 84px;
          height: 31px;
          line-height: 31px;
          span{
            display: inline-block;
            margin-right: 20px;
            // width:72px;
            // height:12px;
            font-size:12px;
            font-weight:500;
            color:rgba(122,129,137,1);
            line-height:23px;
          }
          .closeButton{
            cursor: pointer;
            &:hover{
              color:#4a98ff;
            }
          }
          .contentButton{
            width:76px;
            height:31px;
            background:rgba(74,152,255,1);
            border-radius:16px;
            font-size:13px;
            line-height: 31px;
            font-weight:400;
            color:rgba(255,255,255,1);
            float: right;
            margin-right: 20px;
            text-align: center;
            cursor: pointer;
          }
        }&.newGuidelines1{
          top: 50px;
        }
        &.newGuidelines2{
          top: 110px;
        }&.newGuidelines3{
          top: 170px;
        }&.newGuidelines4{
          right: 45px;
          top: -14px;
          &::before{
            border-left: 20px solid transparent;
            border-right: 20px solid transparent;
            border-top: 20px solid transparent;
            border-bottom: 20px solid #fff;
            left: 202px;
            top: -40px;
            content: "";
          }
          .brightMask{
            top: -65px;
            left: 200px;
          }
        }
        &.newGuidelines5{
          top: 330px;
        }
      }
    }
  }
  .maskOuter{
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }
  .article{// 文章
    margin-top:18px;
    padding:10px 42px 36px;
    background:white;
    &-card{
      padding:26px 23px 26px 16px;
      .title{
        font-size:14px;
        color:$color-black;
        line-height:24px;
        height:44px;
        margin-bottom:20px;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
      }
      .bottom{
        font-size:12px;
        color:$color-gray-tint;
        p{margin-bottom:8px;}
        .tag{
          bottom:0;
          right:0;
        }
      }
    }
  }
  .showQuDaoStyle{
    background-color: #f5f5f5 !important;
  }
  .adv{
    //margin:19px 0 20px;
    margin: 0 0 20px;
    background:white;
    height:120px;
    overflow: hidden;
    position: relative;
    .wrapperAdv{
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .swiper-pagination1{
      width: 120px;
      position: absolute;
      bottom: 10px;
      right: 0;
      left: 0;
      margin: auto;
      z-index: 10;
    }
    .swiper-button-prev{
      width: 25px;
      height: 25px;
    }
    .swiper-button-next{
      width: 25px;
      height: 25px;
    }
  }
  .link{
    padding:22px 31px 33px;
    background:white;
    border:1px solid #E6E6E6;
    .link-mar-top{margin-top:10px;}
    &-tp{
      h1{
        display:inline-block;
        color:$color-main;
        font-size:$font-main;
        margin-right:30px;
        margin-bottom:0;
        font-weight:bold;
        &:before {
          content: '';
          position: absolute;
          width: 2px;
          height: 16px;
          background: rgba(8, 94, 204, 1);
          left: -10px;
          top: 4px;
        }
      }
      span{
        color:$color-gray-tint;
        font-size:$font-secondary-small;
        margin-right:30px;
      }
      .accounts{
        font-size:$font-secondary-small;
        color:#398BF5;
        margin-right:21px
      }
      a{
        font-size:$font-secondary-small;
        color:#398BF5;
        margin-right:21px
      }
    }
    &-bt{
      margin-top:4px;
      ul{
        border-bottom:1px solid #E8EBF1;
        padding-bottom: 20px;
        li{
          display: inline-block;
          margin-right:38px;
          margin-top: 20px;
          position:relative;
          a{
            color:$color-gray;
            font-size:14px;
          }
          &:after{
            content: '';
            position: absolute;
            width: 1px;
            height: 14px;
            background: #DEE0E5;
            right: -20px;
            top: 3px;
          }
        }
        .new-mar-lf{
          margin-right:25px;
        }
      }
      .last-ul{border:none;}
    }
    .last-ul{
      ul{
        border-bottom:none;
      }
    }
  }
</style>
<style lang="scss">
  .work-detail{
    .el-dialog__wrapper{
      .el-dialog{
        margin-top: 10.5% !important;
      }
    }
  }
  .work {
    .swiper-button-disabled{opacity: 0.5}
    .el-select {
      margin-bottom:9px;
      .el-input__inner {
        width: 266px;
        border-radius: 0;
        height: 32px;
        line-height: 32px;
      }
      .el-input__icon {
        line-height: 32px;
      }
    }
    &-data {
      .v-line{
        border:1px solid #E6E6E6;
      }
      .swiper-button-next2 {
        background: url(../../assets/images/back/work/arrow-right.png);
        right: -40px;
      }
      .swiper-button-prev2 {
        background: url(../../assets/images/back/work/arrow-left.png);
        left: -40px;
      }
      .swiper-button-prev2, .swiper-button-next2 {
        width: 38px;
        height: 67px;
        outline:none;
        top:43%;
        cursor:pointer;
      }
    }
  }
  .article{
    .el-tabs__item{
      font-size:16px;
      color: #999999;
      &:hover{
        color:#085ECC;
      }
    }
    .el-tabs__item.is-active{
      color:#085ECC;
    }
    .el-tabs__active-bar{
      background-color:#085ECC;
    }
    .swiper-button-next3 {
      background: url(../../assets/images/back/work/arrow-right.png);
      right: 2px;
    }
    .swiper-button-prev3 {
      background: url(../../assets/images/back/work/arrow-left.png);
      left: 2px;
    }
    .swiper-button-prev3, .swiper-button-next3 {
      width: 38px;
      height: 67px;
      outline:none;
      top:43%;
      cursor:pointer;
    }
    .swiper-button-disabled{opacity: 0.5}
    .el-tabs__header{margin-bottom:25px;}
  }
  .adv>.wrapperAdv> .swiper-container {
    height: 100%;
  }
  .adv>.swiper-pagination1> .swiper-pagination-bullet {
    background: #fff;
    margin: 0 10px;
  }
  .adv>.swiper-pagination1> .swiper-pagination-bullet-active {
    background: #fff;
    margin: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/WorkBench.vue